import React from "react";
import { Image } from "react-native";
import { tID } from "../../../../../Diathrive/src/utils/TestIdHelper";
import { Images } from "../../../utils/Images";
import styles from "./styles";

const SignUpDetailsContainer = ({ children, testIdScreenName = "" }) => (
  <div
    data-testid={tID(
      `${testIdScreenName ? testIdScreenName + "-" : ""}div-Container`
    )}
    style={styles.container}
  >
    {children}
    <Image
      source={Images.signup}
      style={styles.previewImage}
      resizeMode="stretch"
    />
  </div>
);

export default SignUpDetailsContainer;
